import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import Routes from './routes';
import Maintenance from './component/maintenance';
import store from './redux/store';
import axios from 'axios';

import './assets/style/index.css';

export default class App extends React.Component {
  constructor() {
    super();
    this.state = {
      status: '',
      title: '',
      content: ''
    };
  }
  componentWillMount() {
    if (window.location.search && window.location.search.indexOf('?icanusecreative') > -1) {
      this.setState({status: 'normal'});
    } else {
      axios.get("/maintenance.json")
        .then(res=>{
          if (res && res.title && res.content) {
            this.setState({
              status: 'maintenance',
              title: res.title || 'Coming Soon!',
              content: res.content || ''
            });
          } else {
            this.setState({status: 'normal'});
          }
        })
        .catch(err=>this.setState({status: 'normal'}));
    }
  }
  render() {
    let {status, title, content} = this.state;
    if (status === 'maintenance') {
      return <Maintenance title={title} content={content} />;
    } else if(status === 'normal') {
      return (
        <Provider store={store}>
          <BrowserRouter>
            {Routes}
          </BrowserRouter>
        </Provider>
      )
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app.js